(function(){
  if (window.Shopify && Shopify.designMode) return;

  function stickyBar(){
    if (/\/products\/|\/cart|\/checkout/.test(location.pathname)) return;
    var a = document.createElement('a');
    a.className = 'cl-sticky';
    a.href = '/collections/all';
    a.innerHTML = '<span>Shop the Gift Guide</span><span aria-hidden="true">&rarr;</span>';
    document.body.appendChild(a);
    var footer = document.querySelector('footer');
    function onScroll(){
      var nearFooter = footer && footer.getBoundingClientRect().top < innerHeight;
      a.classList.toggle('is-on', scrollY > 420 && !nearFooter);
    }
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function reveal(){
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('cl-motion');
    var targets = [];
    document.querySelectorAll('main .shopify-section').forEach(function(s, i){
      if (i === 0) return;
      if (s.querySelector('.clm')) return;
      targets.push(s);
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function(t){ t.classList.add('cl-reveal'); io.observe(t); });
    setTimeout(function(){ targets.forEach(function(t){ if (t.getBoundingClientRect().top < innerHeight) t.classList.add('is-in'); }); }, 1500);
  }

  function giftNotePlaceholder(){
    function apply(){
      document.querySelectorAll('textarea.cart-note__instructions').forEach(function(t){
        if (!t.placeholder) t.placeholder = 'Your message, and we will include it with the order';
      });
    }
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }

  function init(){ stickyBar(); reveal(); giftNotePlaceholder(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
